import { gql } from '@apollo/client';
import { messageFields } from '@pv/common/graphql';

export const LIST_CONVERSATIONS = gql`
  query AssistantConversations($contextId: ID!, $beforeId: ID) {
    assistantConversations(contextId: $contextId, beforeId: $beforeId)
  }
`;
export const GET_CONVERSATION = gql`
  query AssistantConversation($id: ID!, $beforeSequence: Int) {
    assistantConversation(id: $id, beforeSequence: $beforeSequence)
  }
`;
export const CREATE_CONVERSATION = gql`
  mutation CreateAssistantConversation(
    $input: CreateAssistantConversationInput!
  ) {
    createAssistantConversation(input: $input) {
      conversation
      errors {
        message
      }
    }
  }
`;
export const ASSISTANT_COMMAND = gql`
  mutation AssistantCommand($input: AssistantCommandInput!) {
    assistantCommand(input: $input) {
      conversation
      errors {
        message
      }
    }
  }
`;
export const EMAIL_DRAFTS = gql`
  query AssistantEmailDrafts($conversationId: ID!) {
    assistantEmailDrafts(conversationId: $conversationId)
  }
`;
export const APPLY_DRAFT = gql`
  mutation ApplyAssistantDraft($input: ApplyAssistantDraftInput!) {
    applyAssistantDraft(input: $input) {
      message {
        id
        ...MessageFields
      }
      revision
      errors {
        message
      }
    }
  }
  ${messageFields}
`;

export const INITIALIZE_UPLOAD = gql`
  mutation InitializeAssistantUpload($input: InitializeAssistantUploadInput!) {
    initializeAssistantUpload(input: $input) {
      result
      errors {
        message
      }
    }
  }
`;
export const FINALIZE_UPLOAD = gql`
  mutation FinalizeAssistantUpload($input: FinalizeAssistantUploadInput!) {
    finalizeAssistantUpload(input: $input) {
      result
      errors {
        message
      }
    }
  }
`;
export const DISCARD_UPLOAD = gql`
  mutation DiscardAssistantUpload($input: DiscardAssistantUploadInput!) {
    discardAssistantUpload(input: $input) {
      result
      errors {
        message
      }
    }
  }
`;
